import React from 'react';

export const fmtMoney = (v) => {
  const n = Number(v || 0);
  if (!n) return '0';
  return Math.round(n).toLocaleString('es-CO', { maximumFractionDigits: 0 });
};

export const parseMoney = (s) => {
  const digits = String(s || '').replace(/[^\d-]/g, '');
  if (!digits || digits === '-') return 0;
  return Number(digits);
};

export const MoneyInput = ({ value, onChange, className = '', disabled, testId, placeholder = '0' }) => (
  <input
    type="text"
    inputMode="numeric"
    disabled={disabled}
    value={value ? fmtMoney(value) : ''}
    placeholder={placeholder}
    onChange={(e) => onChange(parseMoney(e.target.value))}
    onFocus={(e) => e.target.select()}
    className={`h-8 w-full rounded-md border px-2 text-right text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-[#1F3864]/30 ${disabled ? 'bg-slate-50 text-slate-500 border-slate-200' : 'border-slate-300 bg-white'} ${className}`}
    data-testid={testId}
  />
);

export const Field = ({ label, children, className = '' }) => (
  <label className={`block ${className}`}>
    <span className="block text-[11px] font-medium uppercase tracking-wide text-slate-500 mb-1">{label}</span>
    {children}
  </label>
);

export const TextInput = ({ value, onChange, testId, className = '', ...rest }) => (
  <input value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={`h-8 w-full rounded-md border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1F3864]/30 ${className}`} data-testid={testId} {...rest} />
);

export const Casilla = ({ num }) => <span className="inline-block min-w-[22px] rounded bg-slate-100 px-1 text-[10px] font-semibold text-slate-500 text-center">{num}</span>;
